import { NgModule } from "@angular/core";
import { CountryFormatPipe } from "../pipes/operations-side.pipe";
import { CheckVisibilityPipe } from "../pipes/operations-side.pipe";

import { BytesFormaterPipe } from "../pipes/bytes.pipe";
import { ProgressBarStatePipe } from "../pipes/progress-bar.pipe";
import { VehicleListComponent } from "../pages/fleet/components/vehicle-list/vehicle-list.component";
import { PilotListComponent } from "../pages/fleet/components/pilot-list/pilot-list.component";
import { IonicModule } from "@ionic/angular";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { CommonModule } from "@angular/common";
import { InsuranceDetailsComponent } from "../pages/vehicle-form/vehicle-form-components/insurance-details/insurance-details.component";
import { VehicleDetailsComponent } from "../pages/vehicle-form/vehicle-form-components/vehicle-details/vehicle-details.component";
import { VehicleIdentificationComponent } from "../pages/vehicle-form/vehicle-form-components/vehicle-identification/vehicle-identification.component";
import { DrawSelectedTrajectory } from "./drawSelectedTrajectory.directory";
import { CheckboxTreeGeneralComponent } from "../components/checkbox-tree-general/checkbox-tree-general.component";
import { CdkTreeModule } from "@angular/cdk/tree";
import { LeafletCustomContextMenuModule } from 'src/app/components/leaflet-custom-context-menu/leaflet-custom-context-menu.module';
import { NgxDatatableModule } from "@swimlane/ngx-datatable";

import { DataTableComponent } from "../pages/logbooks/components/datatable/datatable.component";
import { AgGridModule } from "ag-grid-angular";
import { LeafletCreateTrajectoryComponent } from "../components/trajectory-creation/leaflet-create-trajectory/leaflet-create-trajectory.component";
import { LeftPanelTreeComponent } from "../components/trajectory-creation/left-panel-tree/left-panel-tree.component";
import { WaypointItemTreeComponent } from "../components/trajectory-creation/waypoint-item-tree/waypoint-item-tree.component";
import { RegionSideComponent } from "../pages/region-maps-page/components/region-side/region-side.component";
import { DirIconPipe } from "../pipes/region-side-icon.pipe";
import { LeafletMapComponent } from "../components/leaflet-map/leaflet-map.component";
import { MapHoverPanelComponent } from "../components/leaflet-map/components/map-hover-panel/map-hover-panel.component";
import { MapLayersPanelComponent } from "../components/leaflet-map/components/map-layers-panel/map-layers-panel.component";
import { DirectoryManagerComponent } from "../components/directory-manager/directory-manager.component";
import { FormProgressBarComponent } from "../components/form-progress-bar/form-progress-bar.component";
import { DirectoryTreeComponent } from "../components/directory-tree/directory-tree.component";
import { FormatNamePipe } from "../pipes/format-name.pipe";
import { LeafletService } from "../services/leaflet.service";
import { NgxMaterialTimepickerModule } from "ngx-material-timepicker";
import { LogbooksMenuComponent } from "../pages/logbooks/components/logbooks-menu/logbooks-menu.component";
import { PilotSummaryComponent } from "../pages/logbooks/components/log-summaries/pilot-summary/pilot-summary.component";
import { HighchartsChartModule } from "highcharts-angular";
import { PilotTableComponent } from "../pages/logbooks/components/log-tables/pilot-table/pilot-table.component";
import { DroneSummaryComponent } from "../pages/logbooks/components/log-summaries/drone-summary/drone-summary.component";
import { DroneTableComponent } from "../pages/logbooks/components/log-tables/drone-table/drone-table.component";
import { BatteriesSummaryComponent } from "../pages/logbooks/components/log-summaries/batteries-summary/batteries-summary.component";
import { BatteryTableComponent } from "../pages/logbooks/components/log-tables/battery-table/battery-table.component";
import { MaintenanceFormComponent } from "../pages/logbooks/components/log-summaries/maintenance-form/maintenance-form.component";
import { MaintenanceTableComponent } from "../pages/logbooks/components/log-tables/maintenance-table/maintenance-table.component";
import { QRCodeComponent, QRCodeModule } from "angularx-qrcode";
import { LogbooksTimeFilter } from "../pages/logbooks/components/logbooks-time-filter/logbooks-time-filter.component";
import { PilotLogbookTemplate } from "../pages/logbooks/components/logbook-templates/pilot-logbook-template/pilot-logbook-template.component";
import { DocumentVisualizerComponent } from "../components/document-visualizer/document-visualizer.component";
import { DroneLogbookTemplate } from "../pages/logbooks/components/logbook-templates/drone-logbook-template/drone-logbook-template.component";
import { NavigationBarComponent } from "../components/navigation-bar/navigation-bar.component";
import { UserMenuComponent } from "../components/user-menu/user-menu.component";
import { BatteryLogbookTemplate } from "../pages/logbooks/components/logbook-templates/battery-logbook-template/battery-logbook-template.component";
import { OperationsService } from "../services/operations.service";
import { ScheduleService } from "../services/schedule.service";
import { DigitalClockComponent } from "../components/digital-clock/digital-clock.component";
import { LocalTimeFromUTC } from "../pipes/date-local-time-from-UTC-pipe";
import { OperationNatureSelectorCellComponent } from "../pages/logbooks/render/opNatureSelector";
import { NiceTimePipe } from "../pipes/nice-time.pipe";
import { CityFormatPipe } from "../pipes/city-format.pipe";
import { PilotInfoCardComponent } from "../pages/fleet/components/pilot-info-card/pilot-info-card.component";
import { DragDropModule } from '@angular/cdk/drag-drop';
import { VehicleInfoCardComponent } from "../pages/fleet/components/vehicle-info-card/vehicle-info-card.component";
import { AddressDetailsComponent } from "../pages/pilot-form/pilot-form-components/address-details/address-details.component";
import { ContactDetailsComponent } from "../pages/pilot-form/pilot-form-components/contact-details/contact-details.component";
import { PilotCertificateComponent } from "../pages/pilot-form/pilot-form-components/pilot-certificate/pilot-certificate.component";
import { MOCCADetailsComponent } from "../pages/pilot-form/pilot-form-components/mocca-details/mocca-details.component";
import { RefreshService } from "../services/refresh.service";
import { FormatAdressPipe } from "../pipes/format-adress.pipe copy";
import { OperatorIdentificationComponent } from "../pages/operator-form/operator-form-components/operator-identification/operator-identification.component";
import { LegalRepresentativeComponent } from "../pages/operator-form/operator-form-components/legal-representative/legal-representative.component";
import { HTTPResponseModalComponent } from "../components/http-response-modal/http-response-modal.component";
import { LeafletModule } from "@asymmetrik/ngx-leaflet";
import { NewRegionCardComponent } from "../components/trajectory-creation/select-region-area/components/new-region-card/new-region-card.component";
import { NewRegionMapFormComponent } from "../components/trajectory-creation/select-region-area/components/new-region-map-form/new-region-map-form.component";
import { SelectRegionAreaComponent } from "../components/trajectory-creation/select-region-area/select-region-area.component";
import { WindyComponent } from "../components/windy/windy.component";
import { TranslateModule } from "@ngx-translate/core";
import { SubOperatorInfoCardComponent } from "../pages/fleet/components/sub-operators-info-card/sub-operator-info-card.component";
import { SubOperatorsListCardComponent } from "../pages/fleet/components/sub-operators-list-card/sub-operators-list-card.component";
import { OperatorInfoComponent } from "../pages/operator-form/operator-form-components/operator-info/operator-info.component";
import { CheckNearInfrastructuresComponent } from "../components/check-near-infrastructures/check-near-infrastructures.component";
import { CheckNearUrbanAreasComponent } from "../components/check-near-urban-areas/check-near-urban-areas.component";
import { CheckNearTracksComponent } from "../components/check-near-tracks/check-near-tracks.component";
import { ColorLegendComponent } from "../components/check-near-infrastructures/color-legend/color-legend.component";
import { TracksService } from "../services/tracks.service";

@NgModule({
    imports: [
        CommonModule,
        ReactiveFormsModule,
        FormsModule,
        IonicModule,
        CdkTreeModule,
        LeafletModule,
        LeafletCustomContextMenuModule,
        NgxDatatableModule,
        AgGridModule,
        NgxMaterialTimepickerModule,
        HighchartsChartModule,
        QRCodeModule,
        DragDropModule,
        TranslateModule,
    ],
    providers: [
        ScheduleService,
        LeafletService,
        OperationsService,
        RefreshService,
    ],
    declarations: [
        ProgressBarStatePipe,
        BytesFormaterPipe,
        CountryFormatPipe,
        CheckVisibilityPipe,
        DirIconPipe,
        FormatNamePipe,
        LocalTimeFromUTC,
        NiceTimePipe,
        CityFormatPipe,
        FormatAdressPipe,

        VehicleListComponent,
        PilotListComponent,
        InsuranceDetailsComponent,
        VehicleDetailsComponent,
        VehicleIdentificationComponent,
        PilotCertificateComponent,
        ContactDetailsComponent,
        AddressDetailsComponent,
        MOCCADetailsComponent,
        PilotInfoCardComponent,
        VehicleInfoCardComponent,
        SubOperatorInfoCardComponent,
        SubOperatorsListCardComponent,
        OperatorInfoComponent,
        OperatorIdentificationComponent,
        LegalRepresentativeComponent,

        DrawSelectedTrajectory,
        CheckboxTreeGeneralComponent,
        LeafletCreateTrajectoryComponent,
        LeftPanelTreeComponent,
        WaypointItemTreeComponent,
        NewRegionCardComponent,
        NewRegionMapFormComponent,
        SelectRegionAreaComponent,
        CheckNearInfrastructuresComponent,
        CheckNearUrbanAreasComponent,
        CheckNearTracksComponent,
        ColorLegendComponent,

        DataTableComponent,

        RegionSideComponent,

        LeafletMapComponent,
        MapHoverPanelComponent,
        MapLayersPanelComponent,
        WindyComponent,
        DirectoryManagerComponent,
        DirectoryTreeComponent,
        DigitalClockComponent,
        HTTPResponseModalComponent,

        FormProgressBarComponent,

        LogbooksMenuComponent,
        PilotSummaryComponent,
        PilotTableComponent,
        DroneSummaryComponent,
        DroneTableComponent,
        BatteriesSummaryComponent,
        BatteryTableComponent,
        MaintenanceFormComponent,
        MaintenanceTableComponent,
        LogbooksTimeFilter,
        PilotLogbookTemplate,
        DocumentVisualizerComponent,
        DroneLogbookTemplate,
        BatteryLogbookTemplate,
        OperationNatureSelectorCellComponent,

        NavigationBarComponent,
        UserMenuComponent,
    ],
    exports: [
        ProgressBarStatePipe,
        BytesFormaterPipe,
        CountryFormatPipe,
        CheckVisibilityPipe,
        DirIconPipe,
        FormatNamePipe,
        LocalTimeFromUTC,
        NiceTimePipe,
        CityFormatPipe,
        FormatAdressPipe,

        VehicleListComponent,
        PilotListComponent,
        InsuranceDetailsComponent,
        VehicleDetailsComponent,
        VehicleIdentificationComponent,
        PilotCertificateComponent,
        ContactDetailsComponent,
        AddressDetailsComponent,
        MOCCADetailsComponent,
        PilotInfoCardComponent,
        VehicleInfoCardComponent,
        SubOperatorInfoCardComponent,
        SubOperatorsListCardComponent,
        OperatorInfoComponent,
        OperatorIdentificationComponent,
        LegalRepresentativeComponent,

        DrawSelectedTrajectory,
        CheckboxTreeGeneralComponent,
        LeafletCreateTrajectoryComponent,
        LeftPanelTreeComponent,
        WaypointItemTreeComponent,

        NgxDatatableModule,
        ReactiveFormsModule,
        FormsModule,
        AgGridModule,
        NgxMaterialTimepickerModule,
        QRCodeModule,

        DataTableComponent,

        RegionSideComponent,
        LeafletMapComponent,
        MapHoverPanelComponent,
        MapLayersPanelComponent,
        WindyComponent,
        DirectoryManagerComponent,
        DirectoryTreeComponent,
        DigitalClockComponent,
        HTTPResponseModalComponent,

        FormProgressBarComponent,

        TranslateModule,

        LogbooksMenuComponent,
        PilotSummaryComponent,
        PilotTableComponent,
        DroneSummaryComponent,
        DroneTableComponent,
        BatteriesSummaryComponent,
        BatteryTableComponent,
        MaintenanceFormComponent,
        MaintenanceTableComponent,
        QRCodeComponent,
        LogbooksTimeFilter,
        PilotLogbookTemplate,
        DocumentVisualizerComponent,
        DroneLogbookTemplate,
        BatteryLogbookTemplate,
        OperationNatureSelectorCellComponent,

        NavigationBarComponent,
        UserMenuComponent,

        CheckNearInfrastructuresComponent,
        CheckNearUrbanAreasComponent,
        CheckNearTracksComponent,
        ColorLegendComponent,
        NewRegionCardComponent,
        NewRegionMapFormComponent,
        SelectRegionAreaComponent,
        LeafletMapComponent,
    ]
})
export class SharedModule {}
